export default __webpack_public_path__ + "static/media/hpeai_2.f4318c95.jpg";